import { render, staticRenderFns } from "./LawList.vue?vue&type=template&id=6c18d3a2"
import script from "./LawList.vue?vue&type=script&lang=js"
export * from "./LawList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports